<template>
  <div class="scene-list">
    <Scene
      v-for="scene in scenes"
      :key="scene.id"
      :scene-id="scene.id"
      :scene-name="scene.name"
      :image-url="scene.imageUrl"
      :link-url="scene.linkUrl"
      :data-gtm-page="dataGtmPage"
      :data-gtm-click="dataGtmClick"
      @click-scene="onClickScene"
    />
  </div>
</template>
<script>
import Scene from '../../../scenes/Scene.vue'
export default {
  components: { Scene },
  props: {
    scenes: {
      type: Array,
      required: true
    },
    dataGtmPage: {
      type: String,
      required: false,
      default: null
    },
    dataGtmClick: {
      type: String,
      required: false,
      default: null
    }
  },
  mounted() {
    this.$nextTick(function () {
      this.$emit('mount')
    })
  },
  methods: {
    onClickScene(sceneId) {
      this.$emit('click-scene', sceneId)
    }
  }
}
</script>
<style lang="scss" scoped>
.scene-list {
  @extend %custom-scrollbar;
  display: flex;
  overflow: visible;
  gap: 8px;
}
</style>
